import { TrackJS } from 'trackjs';
import { Session } from '../Api/Types';

/**
 * TrackJS error monitoring
 */
export class TrackJs {
    private static installed = false;

    /**
     * Activate TrackJS monitoring if enabled per configuration
     */
    public static activateIfEnabled(ui: string) {
        const token = document.querySelector<HTMLMetaElement>('meta[name="leaddesk-trackjs-token"]')?.content;
        const application = document.querySelector<HTMLMetaElement>('meta[name="leaddesk-trackjs-application"]')?.content;
        if (token && application) {
            TrackJS.install({ token, application });
            this.installed = true;
            TrackJS.addMetadata('ui', ui);
        }
    }

    /**
     * Add session details as meta information for trackJS
     *
     * @param {Session} session information
     */
    public static addSessionMeta(session: Session) {
        TrackJS.addMetadata('client', String(session.client.id));
        TrackJS.addMetadata('uid', String(session.user.uid));
        TrackJS.addMetadata('level', String(session.user.role));
    }

    /**
     * Add campaigns details as meta information for trackJS
     *
     * @param {number} campaignId
     */
    public static addCurrentCampaignId(campaignId: number | string) {
        TrackJS.addMetadata('campaign.id', String(campaignId));
    }

    /**
     * Report custom error to TrackJS
     *
     * @param error error to report
     */
    public static track(error: Parameters<typeof TrackJS.track>[0]): void {
        if (this.installed) {
            TrackJS.track(error);
        }
    }
}
